import { render, staticRenderFns } from "./MarketplaceAttachment.vue?vue&type=template&id=78a45b8d&scoped=true&"
import script from "./MarketplaceAttachment.vue?vue&type=script&lang=js&"
export * from "./MarketplaceAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a45b8d",
  null
  
)

export default component.exports